import MUSlider from '@material-ui/core/Slider';

export default function Slider(props: Parameters<typeof MUSlider>[0]) {
	return <MUSlider {...props} />;
}
